<div mat-dialog-title *ngIf="hasReferrer" class="bg-white d-flex align-items-center justify-content-between">
	<div class="dialog-title-text w-100 fw-bold">{{ 'register.referrer_title' | translate }}</div>
    <button mat-icon-button aria-label="close dialog" (click)="close()" tabindex="-1">
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content>
	<ng-container *ngIf="!hasReferrer">
		<div class="row justify-content-center my-3">
			<img src="assets/image/referrer_img.png" class="img-fluid" alt="Referrer" />
		</div>
		<div class="text-center h5 mb-3 fw-bold">{{ 'register.has_referral_code' | translate }}</div>
		<div class="text-center mb-0 text-muted">{{ 'register.has_referral_code_desc' | translate }}</div>
	</ng-container>
	<ng-container *ngIf="hasReferrer">
		<form [formGroup]="form" (ngSubmit)="onSubmit()">
			<div class="form-group">
				<label class="text-dark">{{ 'register.referrer-name' | translate }}</label>
				<input
					matInput
					class="form-control"
					formControlName="referrer_name"
					placeholder="{{ 'register.referrer-name' | translate }}"
				/>
			</div>
			<div class="form-group">
				<label class="text-dark">{{ 'register.referrer-phone' | translate }}</label>
				<input
					matInput
					class="form-control"
					formControlName="referrer_phone"
					placeholder="e.g；0123456789"
				/>
				<div *ngIf="form.controls.referrer_phone.touched && form.controls.referrer_phone.errors">
					<mat-error *ngIf="form.controls.referrer_phone.errors.required">{{ 'register.phone_req' | translate }}</mat-error>
					<mat-error *ngIf="form.controls.referrer_phone.errors.pattern">{{ 'register.phone_valid' | translate }}</mat-error>
				</div>
			</div>
		</form>
	</ng-container>
	<div class="dialog-actions mt-5">
		<div class="d-flex justify-content-center" *ngIf="!hasReferrer">
			<button mat-button class="col-lg-6 col-sm-12" mat-dialog-close>{{ 'register.button_label_no' | translate }}</button>
			<button mat-flat-button class="col-lg-6 col-sm-12" color="accent" (click)="hasReferrer = !hasReferrer">{{ 'register.button_label_yes' | translate }}</button>
		</div>
		<div class="d-flex justify-content-center" *ngIf="hasReferrer">
			<button mat-button class="col-lg-6 col-sm-12" (click)="close()">{{ 'register.button_label_skip' | translate }}</button>
			<button mat-flat-button class="col-lg-6 col-sm-12" color="accent" (click)="onSubmit()" [disabled]="form.invalid">{{ 'register.button_label_comfirm' | translate }}</button>
		</div>
	</div>
</mat-dialog-content>
